import CopyToClipboard from 'react-copy-to-clipboard';
import { CheckCircle } from 'flowbite-react-icons/solid';
import { useState, useCallback } from 'preact/hooks';
import toast from 'react-hot-toast';
import PropTypes from 'prop-types';
import OBSDimensions from '@components/overlays/shared/obs-dimensions.jsx';
import LinkSetupStepIcon from '@components/overlays/social/link-setup/link-setup-step-icon.jsx';

SimpleLinkSetup.propTypes = {
  overlayName: PropTypes.string.isRequired,
  overlayURL: PropTypes.string.isRequired,
  obsDimensions: PropTypes.oneOfType([
    PropTypes.shape({
      width: PropTypes.string,
      height: PropTypes.string,
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        width: PropTypes.string,
        height: PropTypes.string,
      })
    ),
  ]),
  orientation: PropTypes.string,
};

export default function SimpleLinkSetup({
  overlayName,
  overlayURL,
  obsDimensions,
  orientation,
}) {
  const [copied, setCopied] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);

  const didCopy = useCallback(() => {
    setCopied(true);
    setCurrentStep(5);
    const timeout = setTimeout(() => {
      setCopied(false);
    }, 1800);

    toast(
      <>
        <CheckCircle />
        <span>Copied to clipboard</span>
      </>,
      {
        position: 'top-center',
        className: 'alert-success text-white',
      }
    );

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <div className="min-h-96 xl:mt-4 max-w-[1500px]">
      <div className="collapse collapse-arrow bg-neutral-50 border-neutral-100 shadow-sm bordered border-2 collapse-open">
        <input type="radio" name="link-setup" defaultChecked={true} />
        <div className="collapse-title text-sm md:text-xl font-medium flex items-center">
          <LinkSetupStepIcon currentStep={currentStep} step={1} />
          <span>Add the {overlayName} to OBS</span>
        </div>
        <div className="collapse-content">
          <article className="prose text-xs mb-2 mt-2">
            Copy and paste the overlay link (below) into your streaming software
          </article>
          <input
            type="text"
            value={overlayURL}
            readOnly
            className="input input-bordered mb-4 w-full "
          />

          <CopyToClipboard text={overlayURL} onCopy={didCopy}>
            <button
              data-track="copy-link"
              className={`btn ${copied ? 'btn-neutral' : 'btn-secondary'} w-full flex items-center justify-center`}
            >
              <span>{copied ? 'Copied' : 'Copy Link to Clipboard'}</span>
            </button>
          </CopyToClipboard>

          <div className="mt-10">
            <p>
              <strong>Add overlay to OBS:</strong>
            </p>

            <ol>
              <li>
                1. Add a new browser source and give it a name like &apos;St.
                Jude {overlayName}&apos;
              </li>
              <li>2. Copy and paste url into URL field</li>
              <OBSDimensions
                obsDimensions={obsDimensions}
                orientation={orientation}
              />
              <li>4. Click OK</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}
